"use strict"
import React, {useEffect, useState} from "react"
import {observer} from "mobx-react"
import fields from "./fields"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import api from "../../global/actions/api"
import {Container, Grid, Link, Tab, Tabs, Typography} from "@material-ui/core"
import {injectIntl} from "react-intl"
import XsInput from "../../global/ui/xsInput/xsInput"
import XsAutocomplete from "../../global/ui/xsInput/xsAutocomplete"
import XsNumberInput from "../../global/ui/xsInput/xsNumberInput"
import dvr from "mobx-react-form/lib/validators/DVR"
import AddIcon from "@material-ui/icons/Add"
import GlobalStore from "../../global/store/GlobalStore"
import XsConfirmationDialog from "../../global/ui/xsDialog/xsConfirmationDialog"
import XsButton from "../../global/ui/xsButton/xsButton"
import XsChipForm from "../../global/ui/xsChipForm/xsChipForm"
import XsChip from "../../global/ui/xsChip/xsChip"
import XsIconButton from "../../global/ui/xsButton/xsIconButton"
import RequestFormStore from "./RequestFormStore"
import RouterStore from "../../global/store/RouterStore"
import XsSearchSelect from "../../global/ui/xsSearchSelect/xsSearchSelect"
import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"
import {isIBANValid} from "../../global/helpers/functions"
import Dropzone from "react-dropzone"
import DeviceDialog from "./DeviceDialog"
import DeviceDialogStore from "./DeviceDialogStore"
import {getUserCompanyInfo, isReadonlyRole} from "../../global/helpers/actions"
import XsTable from "../../global/ui/xsTable/xsTable"
import moment from "moment"
import XsDatePicker from "../../global/ui/xsDatePicker/xsDatePicker"

const columns = [
	{
		Header: "Dátum zmeny stavu žiadosti",
		width: 100,
		accessor: "date",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Login používateľa / email",
		width: 100,
		accessor: "login"
	},
	{
		Header: "Stav",
		width: 100,
		accessor: "state"
	}
]

function RequestForm(props) {
	const hooks = {
		onSubmit(form) {
			logger("........", form.$("request_status").value)
			const photovoltaic_panels = isNotEmpty(form.$("photovoltaic_panels").value)
				? +form.$("photovoltaic_panels").value
				: 0
			const heat_pumps = isNotEmpty(form.$("heat_pumps").value) ? +form.$("heat_pumps").value : 0
			const solar_collectors = isNotEmpty(form.$("solar_collectors").value) ? +form.$("solar_collectors").value : 0
			const wind_turbines = isNotEmpty(form.$("wind_turbines").value) ? +form.$("wind_turbines").value : 0
			const paid_ea_grant = isNotEmpty(form.$("paid_ea_grant").value) ? +form.$("paid_ea_grant").value : 0

			if (
				form.$("request_status").value === "paid" &&
				photovoltaic_panels == 0 &&
				heat_pumps == 0 &&
				solar_collectors == 0 &&
				wind_turbines == 0
			) {
				form.$("photovoltaic_panels").invalidate()
				form.$("heat_pumps").invalidate()
				form.$("solar_collectors").invalidate()
				form.$("wind_turbines").invalidate()
				GlobalStore.setNotificationMessage("Súčet finančných príspevkov musí byť vačší ako 0", null, "error")
				//sucet prispevkov na zariadenia nesmie presiahnut financny prispevok 50000
				//suma prispevku na audit nesmie presiahnut hodnotu 2500 €
			}

			if (form.$("request_status").value === "contracted") {
				if (photovoltaic_panels + heat_pumps + solar_collectors + wind_turbines > 50000) {
					form.$("photovoltaic_panels").invalidate()
					form.$("heat_pumps").invalidate()
					form.$("solar_collectors").invalidate()
					form.$("wind_turbines").invalidate()
					GlobalStore.setNotificationMessage(
						"Súčet finančných príspevkov na zariadenie nesmie presiahnúť hodnotu 50 000 €.",
						null,
						"error"
					)
				}

				if (paid_ea_grant > 2500) {
					form.$("paid_ea_grant").invalidate()
					GlobalStore.setNotificationMessage(
						"Suma príspevku na audit nesmie presiahnúť hodnotu 2 500 €.",
						null,
						"error"
					)
				}
			}
		},
		onSuccess(form) {
			logger("SAVE", form.values())
			RequestFormStore.changeRecordStatus(form)
		},
		onError(form) {
			logger("CHYBY:", form.errors())
			GlobalStore.setNotificationMessage("Skontrolujte povinné polia", null, "error")
		}
	}

	const [form] = useState(new MobxReactForm(fields.load(), {plugins: {dvr: dvr(validatorjs)}, hooks}))

	const initNewForm = async () => {
		const company = getUserCompanyInfo() || {}

		form.$("companyName").value = company.name
		form.$("ico").value = company.identifier

		RequestFormStore.defaultFormValues = form.values()
	}

	useEffect(() => {
		RequestFormStore.formRef = form
		RequestFormStore.resetDropzones()

		if (isNotEmpty(props.id)) {
			RequestFormStore.loadCodelistAndForm(form, props.id)
		} else {
			initNewForm()
		}
	}, [])

	const handleDrop = (files, index, length, templateName) => {
		for (let fileIndex in files) {
			let file = files[fileIndex]

			if (file.size > 20971520) {
				GlobalStore.setNotificationMessage("Súbor je príliš veľký!", null, "error")
				continue
			}
			if (RequestFormStore[`dropedFiles${index}`].length >= length) {
				GlobalStore.setNotificationMessage("Bol prekročený maximálny počet súborov!", null, "error")
				continue
			}

			if (index != "Other") {
				if (index == 0) {
					file.databaseType = "priceComparison"
				}
			} else {
				file.databaseType = "General"
			}
			file.templateName = templateName
			RequestFormStore[`dropedFiles${index}`].push(file)
		}
	}

	const handleDropzoneDelete = (attachmentIndex, dropzoneIndex) => {
		if (isSafe(RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex]._id)) {
			RequestFormStore.deleteLoadedAttachemnt(
				RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex]._id,
				dropzoneIndex,
				attachmentIndex
			)
		} else {
			RequestFormStore[`dropedFiles${dropzoneIndex}`].splice(attachmentIndex, 1)
		}
	}

	const isFormDisabled = () => {
		return true
	}

	const handleChange = (event, newValue) => {
		RequestFormStore.tabValue = newValue
	}

	const getRequestStatus = () => {
		if (isSafe(GlobalStore.CL["requestStatus"]) && GlobalStore.CL["requestStatus"].length > 0) {
			if (RequestFormStore.currentRequestStatus === "sent") {
				return GlobalStore.CL["requestStatus"].filter(
					(rs) =>
						rs._id === "contracted" ||
						rs._id === "reject" ||
						rs._id === "withdrawn" ||
						rs._id === "stopped" ||
						rs._id === "sent"
				)
			}

			if (RequestFormStore.currentRequestStatus === "contracted") {
				return GlobalStore.CL["requestStatus"].filter(
					(rs) =>
						rs._id === "paid" ||
						rs._id === "reject" ||
						rs._id === "withdrawn" ||
						rs._id === "stopped" ||
						rs._id === "contracted"
				)
			}

			if (RequestFormStore.currentRequestStatus === "instack") {
				return GlobalStore.CL["requestStatus"].filter(
					(rs) => rs._id === "sent" || rs._id === "stopped" || rs._id === "instack"
				)
			}

			if (RequestFormStore.currentRequestStatus === "paid") {
				return GlobalStore.CL["requestStatus"].filter((rs) => rs._id === "paid")
			}

			GlobalStore.CL["requestStatus"].filter((rs) => rs._id === "paid" || rs._id === "reject" || rs._id === "withdrawn")
		}

		return []
	}

	const readonlyRole = isReadonlyRole()

	logger(".....request_status....", form.$("request_status").value)

	return (
		<React.Fragment>
			<Container maxWidth="lg">
				<div style={{display: "inline-block", marginTop: 50, backgroundColor: "white", width: "100%"}}>
					<Tabs value={RequestFormStore.tabValue} onChange={handleChange} indicatorColor="primary" textColor="primary">
						<Tab label="DETAIL ŽIADOSTI" value="detail" />
						<Tab label="STAVY ŽIADOSTI" value="state" />
					</Tabs>
					{RequestFormStore.tabValue === "detail" && (
						<React.Fragment>
							<Container maxWidth="lg" className="request_form_fields">
								<Grid container spacing={2} className="pt-8">
									<Grid item xs={12}>
										<Typography variant="h4">
											Žiadosť o vydanie poukážky {form.$("gd_request_id").value || ""}
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="body1" className="mb-3 bold">
											Upraviť žiadosť o vydanie poukážky je možné kedykoľvek až do jej odoslania.
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="h5">1. Údaje o žiadateľovi</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="body2">Polia označené * sú povinné.</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="body1" className="bold">
											Identifikácia žiadateľa
										</Typography>
									</Grid>

									<Grid item xs={12} md={6} lg={4}>
										<XsInput field={form.$("companyName")} disabled />
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<XsNumberInput field={form.$("ico")} disabled step={"1"} min={"1"} />
									</Grid>
									<Grid item xs={12} md={6} lg={4}>
										<XsSearchSelect
											field={form.$("companyLegalForm")}
											disabled={isFormDisabled()}
											items={GlobalStore.CL["legalForm"]}
											specialTooltip={
												"Ak ste vybrali možnosť Iný typ právnej formy, doplňte prosím informáciu o inom type v časti žiadosti Predmet ŽoIP - Opis inovačného projektu v poli Doplňujúce údaje."
											}
										/>
									</Grid>

									<Grid item xs={12} md={4}>
										<XsAutocomplete
											field={form.$("companyCity")}
											minLengthForSearch="1"
											api={api.loadEntityCity}
											inputRenderer={(obj) => obj.city_county}
											saveValue={(obj) => obj.code}
											disabled={isFormDisabled()}
										/>
									</Grid>
									<Grid item xs={12} md={4}>
										<XsInput field={form.$("companyStreet")} disabled={isFormDisabled()} />
									</Grid>

									<Grid item container spacing={2}>
										<Grid item xs={12} md={6} lg={4}>
											<XsInput
												field={form.$("companyIBAN")}
												disabled={isFormDisabled()}
												regex={(val) => isIBANValid(val)}
											/>
										</Grid>
										<Grid item xs={12} md={6} lg={2}>
											<XsNumberInput field={form.$("dic")} step={"1"} min={"1"} disabled={isFormDisabled()} />
										</Grid>
										<Grid item xs={12} md={6} lg={2}>
											<XsInput field={form.$("icdph")} disabled={isFormDisabled()} />
										</Grid>
									</Grid>

									<Grid item xs={12} md={6} lg={3}>
										<XsSearchSelect
											field={form.$("companySize")}
											disabled={isFormDisabled()}
											items={GlobalStore.CL["companySize"]}
										/>
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<XsSearchSelect
											field={form.$("skNace")}
											disabled={isFormDisabled()}
											items={GlobalStore.CL["skNace"]}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={2} className="mt-4">
									<Grid item xs={12}>
										<Typography variant="body1" className="bold">
											Spôsob komunikácie
										</Typography>
									</Grid>
									<Grid item xs={12} className="mb-2">
										<Typography variant="body1">
											{form.$("methodOfCommunication").value
												? "Počas registrácie ste si zvolili elektronickú formu komunikácie prostredníctvom schránky na portáli slovensko.sk."
												: "Počas registrácie ste si zvolili listovú formu komunikácie."}
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="body1" className="bold">
											Štatutárny orgán žiadateľa / Fyzická osoba oprávnená konať v mene MSP
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="body2">
											V prípade viacerých členov štatutárneho orgánu ich pridáte pomocou kliknutia na znamienko +
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<XsChipForm
											field={form.$("applicantChipForm")}
											label={" "}
											configuration={{
												header: {
													chipsRenderer: (key, dataRow, clickHandler) => (
														<XsChip
															key={key}
															label={
																isSafe(dataRow["name"]) && isNotEmpty(dataRow["name"]["value"])
																	? dataRow["name"]["value"]
																	: ""
															}
															onClick={(e) => clickHandler(false, e, key)}
														/>
													),
													addButtonRenderer: (clickHandler) => (
														<XsIconButton className="xs-default xs-outline" icon={<AddIcon />} onClick={clickHandler} />
													)
												},
												columns: [
													{
														name: "name",
														label: "Priezvisko, Meno, Titul pred, Titul za",
														width: 7,
														validationRule: "required",
														renderer: (field) => <XsInput field={field} disabled={isFormDisabled()} forceRequired />
													}
												],
												options: {
													disabled: isFormDisabled(),
													disableFirstRowDelete: true,
													isFormMode: true,
													isModalMode: false,
													hideButtons: true,
													startOpen: true,
													maxLength: 5,
													hideHeader: true,
													onFormOpen: () => {},
													onFormClose: () => {},
													onFormSave: (vals) => {
														RequestFormStore.locationChipForm = vals
													}
												},
												data: RequestFormStore.locationChipForm
											}}
										/>
									</Grid>

									<Grid item xs={12}>
										<Typography variant="body1" className="bold">
											Kontaktná osoba žiadateľa
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="body2" className="mb-2">
											Upozorňujeme, aby ste kontaktnú osobu zadali uvážene, keďže na jej e-mailovú adresu budú zasielané
											výzvy a oznámenia v rámci procesu posudzovania žiadosti podľa článku R, bod 12 Všeobecných
											podmienok.
										</Typography>
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<XsInput field={form.$("contactPersonName")} disabled={isFormDisabled()} />
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<XsInput field={form.$("contactPersonPhone")} disabled={isFormDisabled()} />
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<XsInput field={form.$("contactPersonMail")} disabled={isFormDisabled()} />
									</Grid>

									<Grid item xs={12}>
										<Typography variant="body1" className="bold">
											Splnomocnená osoba (ak relevantné)
										</Typography>
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<XsInput field={form.$("authorizedPersonName")} disabled={isFormDisabled()} />
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<XsInput field={form.$("authorizedPersonPhone")} disabled={isFormDisabled()} />
									</Grid>
									<Grid item xs={12} md={6} lg={3}>
										<XsInput field={form.$("authorizedPersonMail")} disabled={isFormDisabled()} />
									</Grid>

									<Grid item xs={12}>
										<Typography variant="h5">2. Údaje o projekte</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="body2">Polia označené * sú povinné.</Typography>
									</Grid>

									<Grid item xs={12} md={6} lg={4}>
										<XsInput field={form.$("round_text")} disabled />
									</Grid>

									<Grid item container className="mb-2 mt-2" justify="space-between" alignItems="center">
										<Grid>
											<Typography variant="body1" className="bold">
												Miesto realizácie projektu
											</Typography>
										</Grid>
										<Grid>
											<XsButton
												icon={<i className="fal fa-plus"></i>}
												onClick={() => {
													DeviceDialogStore.open()
												}}
												disabled={isFormDisabled()}
												text="PRIDAŤ MIESTO REALIZÁCIE PROJEKTU"
											/>
										</Grid>
									</Grid>

									<Grid item xs={12} className="mb-4" style={{border: "3px solid lightgrey", borderRadius: 5}}>
										<Grid container className="bold pt-1 pb-1">
											<Grid item xs={2}>
												Obec
											</Grid>
											<Grid item xs={2}>
												Ulica
											</Grid>
											<Grid container item xs className="pb-2" spacing={2}>
												<Grid item xs={4}>
													Zariadenie
												</Grid>
												<Grid item xs={2} style={{textAlign: "right"}}>
													Výkon
												</Grid>
												<Grid item xs={2} style={{textAlign: "right"}}>
													Kapacita
												</Grid>
												<Grid item xs={2}>
													K. ú.
												</Grid>
												<Grid item xs={2}>
													Číslo parcely
												</Grid>
											</Grid>
											<Grid item style={{width: "50px"}}>
												&nbsp;
											</Grid>
										</Grid>
										{DeviceDialogStore.places.map((place) => {
											return (
												<React.Fragment key={place.cityId}>
													<Grid container className="pa-2 bgGreyLight" alignItems="center" style={{borderRadius: 5}}>
														<Grid item xs={2}>
															{place.city}
														</Grid>
														<Grid item xs={2}>
															{place.street}
														</Grid>
														<Grid item container xs justify="flex-end" spacing={2}>
															<Grid item>
																<XsButton
																	className="xs-success xs-outline"
																	icon={<i className="fal fa-plus fa-lg"></i>}
																	text="PRIDAŤ ĎALŠIE ZARIADENIE"
																	disabled={isFormDisabled()}
																	onClick={() => {
																		DeviceDialogStore.open(place)
																	}}
																/>
															</Grid>
															<Grid item>
																<XsButton
																	className="xs-danger xs-outline"
																	icon={<i className="fal fa-times fa-lg"></i>}
																	text="ODSTRÁNIŤ MIESTO"
																	disabled={isFormDisabled()}
																	onClick={() => {
																		DeviceDialogStore.removePlace(place)
																	}}
																/>
															</Grid>
														</Grid>
													</Grid>
													{place.devices.map((device) => {
														return (
															<Grid container className="pt-2 pb-2" key={`${place.cityId}_${device._id}`}>
																<Grid item xs={2}>
																	&nbsp;
																</Grid>
																<Grid item xs={2}>
																	&nbsp;
																</Grid>
																<Grid container item xs>
																	<Grid container item xs={12} className="pb-2 pt-2" spacing={2}>
																		<Grid item xs={4}>
																			{device.device}
																		</Grid>
																		<Grid item xs={2} style={{textAlign: "right"}}>
																			{device.power &&
																				Number(device.power)
																					.toFixed(3)
																					.replace(".", ",")}
																		</Grid>
																		<Grid item xs={2} style={{textAlign: "right"}}>
																			{device.capacity &&
																				Number(device.capacity)
																					.toFixed(3)
																					.replace(".", ",")}
																		</Grid>
																		<Grid item xs={2}>
																			{device.catastral}
																		</Grid>
																		<Grid item xs={2}>
																			{device.parcel}
																		</Grid>
																	</Grid>
																</Grid>
																<Grid item container style={{width: "50px"}} justify="flex-end">
																	<Grid item>
																		{place.devices.length > 1 && (
																			<XsIconButton
																				className="xs-danger xs-outline"
																				icon={<i className="fal fa-times fa-lg"></i>}
																				disabled={isFormDisabled()}
																				onClick={() => {
																					DeviceDialogStore.removeDevice(place, device)
																				}}
																			/>
																		)}
																	</Grid>
																</Grid>
															</Grid>
														)
													})}
												</React.Fragment>
											)
										})}
									</Grid>

									<Grid item xs={12}>
										<XsCheckbox field={form.$("contributionForEnergyAudit")} disabled={isFormDisabled()} />
									</Grid>

									<Grid item xs={12}>
										<Typography variant="h5">3. Prílohy</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="body2">
											Polia označené * sú povinné. Do každého poľa je možné vložiť len jeden súbor.
										</Typography>
									</Grid>

									<Grid item container>
										{isSafe(RequestFormStore.attachmentTemplates) &&
											RequestFormStore.attachmentTemplates.map((template, dropzoneIndex) => {
												return (
													<Grid item container spacing={2} key={dropzoneIndex}>
														<Grid item xs={12}>
															{template === "GD:GDREQ:ENERGETICAUDIT" && (
																<Typography variant="body1" className="bold">
																	Príloha č.1 – Energetický audit *
																</Typography>
															)}
															{template === "GD:GDREQ:OZE" && (
																<Typography variant="body1" className="bold">
																	Príloha č.2 – Súbor údajov pre monitorovanie OZE *
																</Typography>
															)}
															{template === "GD:GDREQ:MINIMALDECLARATION" && (
																<Typography variant="body1" className="bold">
																	Príloha č.3 – Vyhlásenie žiadateľa o minimálnu pomoc *
																</Typography>
															)}
															{template === "GD:GDREQ:DIVISIONACTIVITY" && (
																<Typography variant="body1">
																	Príloha č.4 – Doklady preukazujúce oddelenie činností, resp. oddelenie účtovníctva (ak
																	relevantné)
																</Typography>
															)}
															{template === "GD:GDREQ:POWEROFATTORNEY" && (
																<Typography variant="body1">Príloha č.5 – Plnomocenstvo (ak relevantné)</Typography>
															)}
															{template === "GD:GDREQ:AFFIDAVIT" && (
																<Typography variant="body1" className="bold">
																	Príloha č.6 – Čestné vyhlásenie *
																</Typography>
															)}
														</Grid>
														<Grid item xs={12}>
															<Dropzone
																onDrop={(files) => {
																	handleDrop(files, dropzoneIndex, 1, template)
																}}
																id="dropzone"
																disabled={isFormDisabled()}
																accept={".pdf"}
															>
																{isSafe(RequestFormStore[`dropedFiles${dropzoneIndex}`]) &&
																RequestFormStore[`dropedFiles${dropzoneIndex}`].length ? (
																	RequestFormStore[`dropedFiles${dropzoneIndex}`].map((file, index) => (
																		<div key={index} className={"dropedFile"}>
																			<i
																				className="fal fa-file icon pointer"
																				onClick={(e) => {
																					e.stopPropagation()
																					// handleDropzonePreview(index, dropzoneIndex)
																					api
																						.downloadFile(
																							`/object/attachment/${file._id}/redirect`,
																							file.name || "file.pdf"
																						)
																						.call()
																				}}
																			/>
																			<i
																				className="far fa-trash-alt deleteIcon"
																				style={isFormDisabled() ? {opacity: 0.5} : {}}
																				onClick={(e) => {
																					e.stopPropagation()
																					if (!isFormDisabled()) {
																						GlobalStore.openConfirmationDialog("xsDeleteAttachmentFromDropzone", {
																							fileIndex: index,
																							dropzoneIndex: dropzoneIndex
																						})
																					}
																				}}
																			/>
																			<br />
																			<div
																				className={"mac_ellipsis"}
																				data-content-start={file.name.substr(0, Math.floor(file.name.length / 2))}
																				data-content-end={
																					"\u200E" + file.name.substr(Math.floor(file.name.length / 2)) + "\u200E"
																				}
																			/>
																		</div>
																	))
																) : (
																	<div
																		className={"dropzonePlaceholder"}
																	>{`Nahrajte súbor jeho potiahnutím (drag and drop) alebo kliknite a vyberte z Vášho súborového systému`}</div>
																)}
															</Dropzone>
														</Grid>
													</Grid>
												)
											})}
									</Grid>
									<Grid item xs={12}>
										Spracúvanie osobných údajov:{" "}
										<Link
											className="pointer"
											onClick={() => window.open("https://www.siea.sk/o-siea/ochrana-osobnych-udajov/")}
										>
											https://www.siea.sk/o-siea/ochrana-osobnych-udajov/
										</Link>
									</Grid>

									<Grid item xs={12}>
										<XsCheckbox field={form.$("personalDataProvided")} disabled={isFormDisabled()} />
									</Grid>
								</Grid>

								<Grid container className="mt-8">
									<Typography variant="h5">4. Predpokladaná hodnota poukážky</Typography>
									<Typography variant="body2" className="redDanger mt-2">
										Upozorňujeme, že suma zobrazená v systéme je orientačná a predstavuje maximálnu možnú výšku
										poukážky. Skutočná suma poukážky uvedená v oznámení o schválení sa môže líšiť, keďže sa určuje podľa
										reálnych údajov o platcovstve DPH, priznaného percenta pomoci, výsledkov energetického auditu, resp.
										iných skutočností.
									</Typography>
								</Grid>

								<Grid container className="mt-8" justify="center">
									<Grid item xs={12} md={6} lg={4} style={{border: "1px solid #CED7D9", borderRadius: 5}}>
										<Typography variant="h3" className="textCenter pt-1 pb-1">
											{form.$("expected_voucher_amount").value} EUR
										</Typography>
									</Grid>
								</Grid>

								<Grid container className="mt-8">
									<Typography variant="h5">Zmena stavu žiadosti</Typography>
								</Grid>

								<Grid container className="mt-8" spacing={2}>
									<Grid item xs={12} md={6}>
										<XsSearchSelect
											field={form.$("request_status")}
											items={getRequestStatus()}
											disabled={readonlyRole}
										/>
									</Grid>
									<Grid item xs={12} md={6}>
										<XsDatePicker field={form.$("paid_date")} disabled={readonlyRole} />
									</Grid>
									<Grid item xs={12} md={6}>
										<XsNumberInput
											field={form.$("photovoltaic_panels")}
											step={"0.01"}
											min={"0"}
											disabled={readonlyRole}
										/>
									</Grid>
									<Grid item xs={12} md={6}>
										<XsNumberInput field={form.$("heat_pumps")} step={"0.01"} min={"0"} disabled={readonlyRole} />
									</Grid>
									<Grid item xs={12} md={6}>
										<XsNumberInput field={form.$("solar_collectors")} step={"0.01"} min={"0"} disabled={readonlyRole} />
									</Grid>
									<Grid item xs={12} md={6}>
										<XsNumberInput field={form.$("wind_turbines")} step={"0.01"} min={"0"} disabled={readonlyRole} />
									</Grid>
									<Grid item xs={12} md={6}>
										<XsNumberInput field={form.$("paid_ea_grant")} step={"0.01"} min={"0"} disabled={readonlyRole} />
									</Grid>
								</Grid>
							</Container>

							<Container maxWidth="lg" className="mt-8 mb-8">
								<Grid item container justify="space-between">
									<Grid item>
										<XsButton
											icon={<i className="fal fa-arrow-left"></i>}
											onClick={() => {
												RouterStore.push(`/requests`)
											}}
											disableTextTransform
											text="SPAŤ NA ZOZNAM ŽIADOSTÍ"
										/>
									</Grid>
									{!readonlyRole && (
										<Grid item>
											<XsButton
												icon={<i className="fal fa-check"></i>}
												onClick={(e) => {
													e.preventDefault()
													delayedCallback(300, () => {
														form.onSubmit(e)
													})
												}}
												disableTextTransform
												text="POTVRDIŤ ZMENU STAVU ŽIADOSTI"
											/>
										</Grid>
									)}
								</Grid>
							</Container>
						</React.Fragment>
					)}
					{RequestFormStore.tabValue === "state" && (
						<Container maxWidth="lg" className="request_form_fields pt-8 pb-8">
							<Grid container>
								<Grid item xs={12}>
									<Typography variant="h4">Žiadosť o vydanie poukážky {form.$("gd_request_id").value || ""}</Typography>
								</Grid>
								<Grid item xs={12} className="pt-8">
									<XsTable
										columns={columns}
										data={RequestFormStore.requestStates}
										onRowClick={(row) => RouterStore.push(`/request?id=${row.request_id}`)}
									/>
								</Grid>
							</Grid>
						</Container>
					)}
				</div>
			</Container>
			<DeviceDialog />
			<XsConfirmationDialog
				name="xsDeleteAttachmentFromDropzone"
				title={"Pozor"}
				text={"Naozaj chcete odstrániť prílohu?"}
				onConfirmation={() =>
					handleDropzoneDelete(
						GlobalStore.confirmationDialogParams.fileIndex,
						GlobalStore.confirmationDialogParams.dropzoneIndex
					)
				}
			/>
			<XsConfirmationDialog
				name="xsCloseRequestForm"
				text="Naozaj chcete opustiť formulár a zahodť zmeny?"
				confirmBtn={{
					icon: <i className="fal fa-check" />,
					text: "Common.btn.yes"
				}}
				cancelBtn={{
					icon: <i className="fal fa-times" />,
					text: "Common.btn.no"
				}}
				onConfirmation={() => {
					form.reset()
					RouterStore.push("/requests")
				}}
			/>
		</React.Fragment>
	)
}

export default injectIntl(observer(RequestForm))

